import React from 'react';
import {Box, Link} from '@tempo/core';
import {Trans, useTranslation} from 'next-i18next';

const DisclaimerTerms = () => {
	const {t} = useTranslation('d4c');
	return (
		<Box textAlign="center">
			<Trans
				components={{
					bold: <strong />,
					LinkToTerms: (
						<Link
							data-testid="terms-conditions-button"
							href="https://www.deezer.com/legal/cgu"
							isExternal={true}
							variant="deezer"
						/>
					),
					LinkToPolicy: (
						<Link
							data-testid="privacy-policy-button"
							href="https://www.deezer.com/legal/personal-datas"
							isExternal={true}
							variant="deezer"
						/>
					),
				}}
			>
				{t('signuppage_text_createaccountaccepttcsandpp_d4c-web')}
			</Trans>
		</Box>
	);
};

export default DisclaimerTerms;
